import React, { Component } from 'react';
import { reduxForm, SubmissionError } from 'redux-form';
import PodcastValidator from '../../validators/PodcastValidator'
import InputField from '../Inputs/InputField'


class PodcastForm extends Component {
    constructor(props) {
	super(props);
	this.state = {
	    waiting: false,
	    authorized: undefined
	}
    }
 
    
    render() {
	const { handleSubmit, successAction } = this.props
	let {waiting} = this.state
	
	const submit = (values, dispatch, props) => {
	    let errors = PodcastValidator( values, props ) || {};
	    waiting=true
	    this.setState({waiting})
	    if (Object.keys(errors).length) {
		throw new SubmissionError(errors);
	    } else {
		let saveAction = values.id ? props.updatePodcast : props.savePodcast	
		saveAction(values).then((res) => {
		    waiting=false
		    this.setState({waiting})
		    props.reset()
		    successAction()
		}).catch((err) => {
		    waiting=false
		    this.setState({waiting})
		    console.log(err)})
	    }
	}

	

	return (

	    <form onSubmit={handleSubmit(submit)}>		
		<InputField name="title" type="text" label="Naslov" />
		<InputField name="description" type="textarea2" label="Opis" />

		<button type="submit" disabled={this.props.invalid || waiting} className="btn btn-brown btn-big full-width" >
		    <i style={{display: (waiting ? 'inline-block' : 'none' )}} className="fa fa-spinner fa-spin"></i>
		    {
			this.props.invalid ?
			'Pomankljivosti v unosu podtkov poglej zgoraj'
			:
			'Sharni'
		    }
		</button>
	    </form>
	);
    }
}

export default reduxForm({
    form: 'podcast',
    validate: PodcastValidator,
    enableReinitialize: true
})(PodcastForm);



// WEBPACK FOOTER //
// ./src/components/PodcastForm/index.jsx